import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';
import { Modal, ModalWidth } from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

import { DocplannerServiceMappingCreateButton } from './DocplannerServiceMappingCreateButton';
import { DocplannerServiceMappingCreateForm } from './DocplannerServiceMappingCreateForm';
import { DocplannerServiceMappingCreateModalExitButtons } from './DocplannerServiceMappingCreateModalExitButtons';

type DocplannerServiceMappingCreateModalProps = {
   readonly onMappingCreateSuccess: VoidFunction;
   readonly onClose: VoidFunction;
   readonly alreadySelectedServicesIds: number[] | undefined;
};

type UseDocplannerServiceMappingCreateModalStateReturn = [open: VoidFunction, close: VoidFunction, opened: boolean];

export const useDocplannerServiceMappingCreateModalState = (): UseDocplannerServiceMappingCreateModalStateReturn => {
   const [{ setTrue, setFalse }, mappingModalOpened] = useBoolean();
   return [setTrue, setFalse, mappingModalOpened];
};

export const DocplannerServiceMappingCreateModal = (props: DocplannerServiceMappingCreateModalProps): ReactElement => {
   return (
      <Modal
         testId={'DocplannerServiceMappingCreate'}
         title={medicalServicesMappingsTranslationKeys.addMapping}
         width={ModalWidth.NORMAL}
      >
         <DocplannerServiceMappingCreateForm alreadySelectedServicesIds={props.alreadySelectedServicesIds}>
            {({ handleSubmit, formState }) => (
               <>
                  <DocplannerServiceMappingCreateButton
                     handleSubmit={handleSubmit}
                     onSuccess={props.onMappingCreateSuccess}
                  />
                  <DocplannerServiceMappingCreateModalExitButtons
                     onClose={props.onClose}
                     shouldConfirmExit={formState.isDirty}
                  />
               </>
            )}
         </DocplannerServiceMappingCreateForm>
      </Modal>
   );
};
